import { inject, Injectable } from '@angular/core';
import { createHttpResourceLocation, HttpDataAccess } from '@softline/core';
import { AI_TABLE_EXTRACTOR_API_PLAUSIBILITY } from '../ai-table-extractor.api';
import {
  DEFAULT_AI_TABLE_EXTRACTOR_CONFIG,
  SOFTLINE_CONFIG_AI_TABLE_EXTRACTOR,
} from '../ai-table-extractor.shared';
import {
  PlausibilityItemInput,
  PlausibilityRequest,
  PlausibilityResponse,
  PlausibilityRow,
} from '../types/plausibility';

/**
 * `POST /plausibility` — the service computes the check rows with the same
 * arithmetic as its pipeline. Never re-implement that math client-side.
 */
@Injectable()
export class PlausibilityRepository {
  private readonly dataAccess = inject(HttpDataAccess);
  private readonly config = inject(SOFTLINE_CONFIG_AI_TABLE_EXTRACTOR);

  async check(item: PlausibilityItemInput): Promise<PlausibilityRow[]> {
    const baseUrl =
      this.config.apiBaseUrl ?? DEFAULT_AI_TABLE_EXTRACTOR_CONFIG.apiBaseUrl;
    const response = await this.dataAccess.create<
      PlausibilityRequest,
      PlausibilityResponse
    >(
      createHttpResourceLocation({ url: baseUrl + AI_TABLE_EXTRACTOR_API_PLAUSIBILITY }),
      { item }
    );
    return response.rows;
  }
}
